
import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const EditSensorNameModalWrapper = styled(Modal)`
  .btn-success {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
  }

  /* User card styling */
  .user-card {
    border: 1px solid #f0f0f0;
    border-radius: 3px;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #d9d9d9;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    &.active {
     border-color: #0B2A1B;
      background-color: #f6ffed;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
      
      .ant-card-body {
        padding: 12px 16px;
      }
    }
  }

  /* Users list container */
  .users-list {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 8px;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
      
      &:hover {
        background: #a8a8a8;
      }
    }
  }

  /* Collapse panel customization */
  .ant-collapse-ghost > .ant-collapse-item > .ant-collapse-header {
    padding: 8px 0;
    font-weight: 500;
  }

  .ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 16px 0 0 0;
  }

  /* Card titles */
  .ant-card-head-title {
    font-size: 14px;
    font-weight: 600;
  }

  /* Checkbox group spacing */
  .ant-checkbox-group {
    .ant-checkbox-wrapper {
      margin-right: 8px;
      
      &:last-child {
        margin-right: 0;
      }
    }
  }

  /* Form improvements */
  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
  }

  /* Input number improvements */
  .ant-input-number {
    .ant-input-number-input {
      text-align: center;
    }
  }

  /* Modal content spacing */
  .ant-modal-body {
    padding: 24px;
  }

  /* Space component improvements */
  .ant-space-vertical > .ant-space-item:last-child {
    margin-bottom: 0 !important;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ant-modal {
      margin: 20px;
      max-width: calc(100vw - 40px);
    }
    
    .user-card .ant-checkbox-group {
      flex-direction: column;
      gap: 4px;
    }
  }

  /* Loading state for cards */
  .user-card.loading {
    opacity: 0.7;
    pointer-events: none;
  }

  /* Better visual hierarchy */
  .ant-card {
    .ant-card-head {
      border-bottom: 1px solid #f0f0f0;
      min-height: 44px;
    }
    
    .ant-card-body {
      padding: 16px;
    }
  }

  /* Notification icon styling */
  .anticon-bell {
    animation: ring 2s ease-in-out;
    color: #0B2A1B !important;
  }

  @keyframes ring {
    0% { transform: rotate(0deg); }
    10% { transform: rotate(10deg); }
    20% { transform: rotate(-10deg); }
    30% { transform: rotate(10deg); }
    40% { transform: rotate(-10deg); }
    50% { transform: rotate(0deg); }
    100% { transform: rotate(0deg); }
  }
`;

export default WithDirection(EditSensorNameModalWrapper);